<template>
  <Layout
    :bg="!showLogout ? 'secondary' : ''"
    :backToRoute="showLogout ? false : true"
  >
    <div v-if="!showLogout">
      <div class="primary--text section-title pt-4">
        {{ $t("my_account.title") }}
      </div>
      <div class="mt-13 mx-6">
        <OptionButton
          v-for="(button, i) in optionButtons"
          :key="i"
          :icon="button.icon"
          :label="button.text"
          :secondary="true"
          class="mb-3"
          @click.native="
            button.route
              ? $router.push({ name: button.route })
              : (showLogout = !showLogout)
          "
        />
      </div>
    </div>
    <v-slide-x-transition hide-on-leave>
      <div
        v-if="showLogout"
        class="d-flex flex-column align-center justify-center vertical-semi-centered"
      >
        <v-icon x-large color="primary" class="mb-6">logout</v-icon>
        <div class="title primary--text mb-12">
          {{ $t("my_account.logout") }}
        </div>
        <div class="d-flex mt-8">
          <v-btn
            text
            class="py-8 primary--text px-10 semi-rounded"
            x-large
            @click="showLogout = false"
          >
            {{ $t("actions.cancel") }}
          </v-btn>
          <v-btn
            class="py-8 textOverSecondary--text semi-rounded"
            color="primary"
            x-large
            @click="logout()"
          >
            {{ $t("my_account.confirm_logout") }}
          </v-btn>
        </div>
      </div>
    </v-slide-x-transition>
  </Layout>
</template>
<script>
import Layout from "@/views/layouts/MainLayout";
import OptionButton from "@/components/form-elements/BigButton";
import { mapState } from "vuex";
import RequestMixin from "@/mixins/Requests";

export default {
  props: ["auth", "routeNames"],
  data() {
    return {
      optionButtons: [
        {
          icon: "person",
          text: this.$t("my_account.user_data"),
          route: this.routeNames.USER,
        },
        {
          icon: "qr_code",
          text: this.$t("my_account.show_qr_code"),
          route: this.routeNames.QR,
        },
        {
          icon: "exit_to_app",
          text: this.$t("my_account.confirm_logout"),
        },
      ],
      showLogout: false,
    };
  },
  components: {
    Layout,
    OptionButton,
  },
  mixins: [RequestMixin],
  methods: {
    logout() {
      this.auth.logout(this);
    },
  },
  computed: {
    ...mapState({
      user_name: (state) =>
        state.userData.userData
          ? state.userData.userData.name
            ? state.userData.userData.name
            : state.userData.userData.email.split("@")[0]
          : null,
    }),
  },
  created() {
    if (!this.user_name) {
      this.getUserData();
    }
  },
};
</script>
